export default `vec3 Q=abs(mod(p,1.8)-.9);
    float a=1.;
    float d=1.;
    for(int j=0;j++<8;)
      Q=2.*clamp(Q,-.9,.9)-Q,
      d=dot(Q,Q),
      Q/=d,
      a/=d;
    return (Q.x+Q.y+Q.z-1.3)/a/3.;
  }`